import axios from 'axios';
export var fetchAddress = function fetchAddress(config) {
  return axios.get('/api/home/check-connection/get-address/', config).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};